import { render, staticRenderFns } from "./SimpleResourceInstanceView.vue?vue&type=template&id=84fff3a4&"
import script from "./SimpleResourceInstanceView.vue?vue&type=script&lang=js&"
export * from "./SimpleResourceInstanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports